import MyPresentation from "./views/my-presentation.vue";

export default {
  path: "/my-presentations",
  name: "my-presentations",
  component: MyPresentation,
};
